<template>
    <div class="EnrollExistingSingleParticipantDiv">
        <div class="container-fluid">
            <!-- <div class="row vertical-align margin-Top-0Perc text-align-left">
                <div class="col-md-2 col-lg-2 cursor-pointer" v-on:click="isBackPressed">
                    {{backToMainMenu}}
                </div>
                <div class="col-md-10 col-lg-10">
                </div>
            </div> -->
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                  User(s)
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                          <select class="form-control" v-model="getSelectedUserObj">
                            <option value='-1' disabled>Select</option>
                            <option v-for="userObj in getParticipantList" v-bind:key="userObj.UserId" v-bind:value="userObj">{{ userObj.FirstName }} {{ userObj.LastName }}</option>
                          </select> 
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                    Group Course(s)
                </div>    
                <div class="col-md-4 col-lg-4" v-if="!isCoachUser">
                    <div class="form-group">
                        <div class="col-sm-12">
                          <select class="form-control" v-model="selectedGroupObj" :disabled="getSelectedUserObj === -1">
                              <option value=-1 disabled>Select</option>
                              <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj" v-if="getUserGropId === groupCourseObj.GroupId || groupCourseObj.IsPublic">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-lg-4" v-else>
                    <div class="form-group">
                        <div class="col-sm-12">
                          <select class="form-control" v-model="selectedGroupObj" :disabled="getSelectedUserObj === -1">
                              <option value=-1 disabled>Select</option>
                              <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                    Cohort(s)
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                          <select class="form-control" v-model="getSelectedCohortObjValue" :disabled="getSelectedUserObj === -1">
                            <option value='-1' disabled>Select</option>
                            <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                          </select> 
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                  Is Facilitator
                </div>    
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12 text-align-left">
                          <input type="checkbox" v-model="getIsFacilitatorValue">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-Top-1Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group" v-if="showViewGoalAndActionOption">
                        <div class="col-sm-12">
                          <span class="text-color-blue cursor-pointer text-decoration-underline" @click="openViewGoalOverlay($event)">View Associated Goals & Actions</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    </div>
                </div>
            </div>
            <div class="row margin-bottom-2Perc margin-top-3Perc">    
              <!-- ToDo: Track this -->
              <div class="center-align">
                <button class="btn btn-primary enroll-existing-button-BG black-font-color col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1" @click="enrollParticipant" :disabled="disableEnrollBtn">Enroll Participant</button>
              </div> 
            </div>
            <view-associated-leaps-challenges-for-cohort v-if="openViewGroupChallengeOverlay" :selectedCohortObj="selectedCohortObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-challenges-for-cohort>
            <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performUserConfirmationAction"></confirmation-alert>
            <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
            <!-- Show Spinner -->
            <div class="animationload" v-show="showSpinner">
              <div class="osahanloading"></div>
            </div> 
            <loader></loader>     
        </div>
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import { cohortService } from '@/server-util/cohort-service'
import ViewAssociatedLeapsChallengesForCohort from './group/ViewAssociatedLeapsChallengesForCohort'
import { participantService } from '@/server-util/participant-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      backToMainMenu: '< Back',
      pressedBack: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      selectedUserObj: -1,
      associatedCohortList: [],
      userList: [],
      isFacilitator: false,
      availableLeapsChallengesForCurrentCohort: [],
      openViewGroupChallengeOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      showViewGoalAndActionOption: false,
      disableEnrollBtn: false
    }
  },
  methods: {
    closeVisibleOverlay (value) {
      this.openViewGroupChallengeOverlay = false
      this.$store.state.isOverlayVisible = false
      this.fetchAssociatedGoalsAndActions()
    },
    openViewGoalOverlay: function (event) {
      this.openViewGroupChallengeOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    performUserConfirmationAction: function (value) {
      if (value) {}
    },
    isBackPressed: function () {
      this.$emit('isBackPressed', this.pressedBack)
    },
    enrollParticipant: function () {
      // AK: If user pressd Enroll Participant Button
      var storeObj = this.$store
      var _this = this
      if (this.validateRequiredFieldBeforeSubmit()) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .enrollParticipant(
            storeObj.state.access_token,
            this.selectedUserObj.UserId,
            this.selectedCohortObj.CohortId,
            this.isFacilitator
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + ' is successfully enrolled in \'' + this.selectedGroupObj.CourseTitle + '\'.'
              this.resetFields()
            } else {
              _this.showAlertDialog = true
              _this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.selectedUserObj === -1) {
        this.showAlertDialog = true
        if (this.selectedCohortObj !== -1) {
          this.errorMsg = 'Please select a user to enroll in \'' + this.selectedCohortObj.CohortName + '\' cohort.'
        } else {
          this.errorMsg = 'Please select a user to enroll.'
        }
        return false
      } else if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
        return false
      } else if (this.selectedCohortObj === -1) {
        this.showAlertDialog = true
        if (this.associatedCohortList.length === 0) {
          var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
          this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
        } else {
          this.errorMsg = 'Please select a cohort.'
        }
        return false
      }
      return true
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort(s) found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Group ID is NULL hence declined LISTING Assciated Cohort(s) OPERATION'
        )
      }
    },
    getAllUserList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== '' || storeObj.state.access_token !== undefined || storeObj.state.access_token !== null
      ) {
        participantService
          .getMinParticipantList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: store / Update user list
              _this.userList = responseObj.data
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No user found.'
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured if showing
              if (_this.$store.state.isLoading === true) {
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured if showing
            if (_this.$store.state.isLoading === true) {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LISTING User List OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
              // AK: Issue call to get all Users from server
              _this.getAllUserList()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.errorMsg === 'No goals and actions are associated with this cohort. Please associate it!') {
        this.$store.state.hightLightOptionExplictly = false
        localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Users)
        localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.Cohorts)
        // this.$router.push('/cohorts?openAssGoalOverlay=true&cohortId=' + this.selectedCohortObj.CohortId + '&groupId=' + this.selectedGroupObj.GroupId)
        let routeData = this.$router.resolve({name: 'cohorts', query: {openAssGoalOverlay: 'true', cohortId: this.selectedCohortObj.CohortId, groupId: this.selectedGroupObj.GroupId}})
        window.open(routeData.href, '_blank')
      }
    },
    resetFields: function () {
      // AK: Reset Fields again
      this.selectedGroupObj = -1
      this.selectedCohortObj = -1
      this.selectedUserObj = -1
      this.isFacilitator = false
      this.showViewGoalAndActionOption = false
      this.disableEnrollBtn = false
    },
    fetchAssociatedGoalsAndActions: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
        this.selectedCohortObj !== undefined && this.selectedCohortObj !== 'undefined' && this.selectedCohortObj !== null && this.selectedCohortObj !== 'null' && this.selectedCohortObj !== '' && this.selectedCohortObj !== -1 &&
        !this.openViewGroupChallengeOverlay
      ) {
        this.$store.state.isLoading = true
        cohortService
          .getAvailableChallengeForCohort(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.availableLeapsChallengesForCurrentCohort = responseObj.data.ChallengeActionsData
              if (this.availableLeapsChallengesForCurrentCohort.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No goals and actions are associated with this cohort. Please associate it!'
                this.disableEnrollBtn = true
              } else {
                this.disableEnrollBtn = false
                this.showAlertDialog = false
                this.errorMsg = ''
              }
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.$store.state.isLoading = false
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING AVAILABLE CHALLENGE LIST'
        )
      }
    },
    setDefaultValues: function () {
      window.onfocus = () => {
        if (!this.openViewGroupChallengeOverlay && this.selectedGroupObj !== undefined && this.selectedGroupObj !== 'undefined' && this.selectedGroupObj !== null && this.selectedGroupObj !== 'null' && this.selectedGroupObj !== '' && this.selectedGroupObj !== -1 && this.selectedGroupObj.CourseMasterId === constants.Default_Meeting_Mentor_Course) {
          this.fetchAssociatedGoalsAndActions()
        }
      }
    }
  },
  computed: {
    getSelectedCohortObjValue: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
        if (this.selectedGroupObj.CourseMasterId === constants.Default_Meeting_Mentor_Course) {
          this.fetchAssociatedGoalsAndActions()
          this.showViewGoalAndActionOption = true
          this.disableEnrollBtn = true
        } else {
          this.showViewGoalAndActionOption = false
          this.disableEnrollBtn = false
        }
      }
    },
    getIsFacilitatorValue: {
      get: function () {
        return this.isFacilitator
      },
      set: function (newValue) {
        this.isFacilitator = newValue
      }
    },
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getCreatedParticipantObj: {
      get: function () {
        return this.createdParticipantObj
      }
    },
    getParticipantList: {
      get: function () {
        return this.userList
      }
    },
    getSelectedUserObj: {
      get: function () {
        return this.selectedUserObj
      },
      set: function (newValue) {
        this.selectedUserObj = newValue
        this.selectedGroupObj = -1
        this.associatedCohortList = []
        this.selectedCohortObj = -1
        this.isFacilitator = false
      }
    },
    getUserGropId: {
      get: function () {
        return this.getSelectedUserObj.GroupId
      }
    },
    isCoachUser: {
      get: function () {
        return this.getSelectedUserObj.AccountType === constants.UserAccountType.Coach
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset selectedCohortObj to initial value
      this.selectedCohortObj = -1
      this.isFacilitator = false
      this.getAssociatedCohortList()
    }
  },
  components: {
    'view-associated-leaps-challenges-for-cohort': ViewAssociatedLeapsChallengesForCohort,
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  name: 'EnrollExistingSingleParticipantDiv'
}
</script>

<style scoped>
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2% !important;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-0Perc {
  margin-top: 0%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.enroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right{
  text-align: right !important;
}
.center-align {
    margin: auto;
    width: 20%;
    /* border: 3px solid green; */
    /* padding: 10px; */
}
.margin-top-2Point6Perc {
  margin-top:2.6%;
}
</style>


// WEBPACK FOOTER //
// src/components/EnrollExistingSingleParticipant.vue